import request from "@/CommonDP/utils/request";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";
export default {
  strategyCreate(body) {
    return request.post(`/sys-resource-strategy/save`, body).then(res => res);
  },
  strategyAuthUpdate(body) {
    return request.post(`/sys-resource-strategy/update`, body).then(res => res);
  },
  getStrategyList(params) {
    return request.get(`/sys-resource-strategy/list`, { params }).then(res => res);
  },
  strategyDelete(params) {
    return request.get('/sys-resource-strategy/delete', { params }).then(res => res);
  },
  getStrategyCreateDictList(params) {
    return request.get('/sys-resource-strategy/getDicList', { params }).then(res => res);
  },
  querySysRoleList(params) {
    return request.get('/rolePermission/querySysRoleList', { params }).then(res => res);
  },
  querySpecRoleList(params) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/flow/specRole/queryTree");
    if (isDef(newUrl)) {
      return request.get(`${newUrl}`, { params });
    }
    return request.get('/flow/specRole/queryTree', { params }).then(res => res);
  } ,
  queryPrjoleList(params) {
    return request.get('/flow/queryRoleList', { params }).then(res => res);
  },
  queryDeptList(params) {
    return request.get('/org/tree', { params }).then(res => res);
  },
  queryDeptPersonList(params) {
    return request.post('/org/users/resursive-page', params).then(res => res);
  },
  addResourceAction(params){
    return request.post('/sys-resource-action/add',params).then(res => res)
  },
  queryActionByResourceId(params){
    return request.get('/sys-resource-action/list',{params}).then(res => res)
  },
  delAction(params){
    return request.get('/sys-resource-action/delete',{params}).then(res=>res)
  }
};
